"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = language;

var _setLanguage = require("../actions/setLanguage");

var DEFAULT_STATE = 'en-US';

function language() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case _setLanguage.SET_LANGUAGE:
      state = payload.language;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERUZBVUxUX1NUQVRFIiwibGFuZ3VhZ2UiLCJzdGF0ZSIsInBheWxvYWQiLCJ0eXBlIiwiU0VUX0xBTkdVQUdFIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JlZHVjZXJzL2xhbmd1YWdlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFNFVF9MQU5HVUFHRSB9IGZyb20gJy4uL2FjdGlvbnMvc2V0TGFuZ3VhZ2UnO1xuXG5jb25zdCBERUZBVUxUX1NUQVRFID0gJ2VuLVVTJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gbGFuZ3VhZ2Uoc3RhdGUgPSBERUZBVUxUX1NUQVRFLCB7IHBheWxvYWQsIHR5cGUgfSkge1xuICBzd2l0Y2ggKHR5cGUpIHtcbiAgICBjYXNlIFNFVF9MQU5HVUFHRTpcbiAgICAgIHN0YXRlID0gcGF5bG9hZC5sYW5ndWFnZTtcbiAgICAgIGJyZWFrO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgcmV0dXJuIHN0YXRlO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsYUFBYSxHQUFHLE9BQXRCOztBQUVlLFNBQVNDLFFBQVQsR0FBNEQ7RUFBQSxJQUExQ0MsS0FBMEMsdUVBQWxDRixhQUFrQzs7RUFBQTtFQUFBLElBQWpCRyxPQUFpQixRQUFqQkEsT0FBaUI7RUFBQSxJQUFSQyxJQUFRLFFBQVJBLElBQVE7O0VBQ3pFLFFBQVFBLElBQVI7SUFDRSxLQUFLQyx5QkFBTDtNQUNFSCxLQUFLLEdBQUdDLE9BQU8sQ0FBQ0YsUUFBaEI7TUFDQTs7SUFFRjtNQUNFO0VBTko7O0VBU0EsT0FBT0MsS0FBUDtBQUNEIn0=